import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button, Typography, Row, Col, Select, Form, Input } from 'antd';
import { Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchPagerRight from 'shared_components/search_pager_right';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { PlusCircleOutlined } from '@ant-design/icons';
import { TABLE_HEADER_STYLE, TABLE_CELL_STYLE, TABLE_PAGINATION_STYLE, TABLE_INPUT_STYLE } from 'utils/tableStyles';

// Removed Ant Design editable row/cell wrappers; inline editing is handled directly in MUI cells
import { numberFormat, formatValueOnChange } from 'utils/helper';
import Message from 'shared_components/message';
import { fetchDrDetailsAPI } from 'services/invoice/invoice'
import { UserAccessContext } from 'context/userAccess';
import { fetchUnitsListAPI } from 'services/shared/fetchLovList';


const { Option } = Select;
const { TextArea } = Input;

const InvoiceTable = (
	{ handleTableData, handleTotVal, handleDrList, invDetails, disabled, soldToDisabled, messagesList, 
		unitList, drList, handleDeleteList, tblLoading, isEditting, invDetProps, editButtonClicked, selectedDrIdList
	}
) => {
	// const [loading, setLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [fromInvDetData, setFromInvDetData] = useState([]);
	const [fromDrData, setFromDrData] = useState([]);
	const [fromAddData, setFromAddData] = useState([]);
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	const [count, setCount] = useState(0);
	const { userAccess } = useContext(UserAccessContext);
    const updateInvoiceRight = userAccess['invoices'].update;

	const [editableTableVal, setEditableTableVal] = useState(true);
	const [msgList, setMsgList] = useState([]);
	const [unitName ,setUnitName] = useState();
    const [drData, setDrData] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [unitsList, setUnitsList] = useState([]);
	const [unitsLoading, setUnitsLoading] = useState(true);
	const [editingValues, setEditingValues] = useState({});

	// Add ref to track data state and prevent unnecessary reprocessing during pagination
	const dataTrackingRef = useRef({
		lastInvDetData: [],
		lastDrData: [],
		lastAddData: [],
		isPageNavigation: false
	});

	//DR numbers list
	console.log("🚚 DR LIST DEBUG - SELECT DR NO DROPDOWN:", drList);
	if (Array.isArray(drList)) {
		console.log("🚚 drList array indices:", Object.keys(drList));
		console.log("🚚 drList detailed:", drList.map((item, idx) => ({ idx, dr_id: item && item.dr_id, dr_no: item && item.dr_no })));
	}
	// Filter out invalid entries (strings, null, etc) and keep only valid DR objects
	const cleanDrList = Array.isArray(drList) ? drList.filter(item => 
		typeof item === "object" && 
		item !== null && 
		item.dr_id && 
		item.dr_no
	) : [];
	console.log("🚚 CLEANED DR LIST:", cleanDrList);
	console.log("🚚 Original length:", drList ? drList.length : 0, "Cleaned length:", cleanDrList.length);
    const drNoOptions = cleanDrList
        .sort((a, b) => a.dr_no > b.dr_no ? 1 : -1)
        .map((item, index) => {
        return(
            <Option key={index} label={item.dr_no} value={item.dr_id}>{item.dr_no}</Option>
        );
    });

	//Units list options
    const unitsOptions = unitsList.map((item, index) => {
        return(
            <Option key={index} value={item.unit_name}>{item.unit_name}</Option>
        ); 
    });

	async function getLOVList(){
		try{
			const getUnit = await fetchUnitsListAPI();
			setUnitsList(getUnit);
			if(getUnit && getUnit.length > 0){
				setUnitName(getUnit[0].unit_name);
			}
			setUnitsLoading(false);
		}catch(error){
			console.log("getLOVList error", error);
			setUnitsLoading(false);
		}
	};

	// Fetch units list on component mount
	useEffect(() => {
		getLOVList();
	}, []);

	// invDetData( from Invoice Details Table - DB )
	useEffect(() => {
		console.log('🔥 invDetails useEffect TRIGGERED');
		console.log('🔥 invDetails prop:', invDetails);
		console.log('🔥 invDetails length:', invDetails ? invDetails.length : 0);
		console.log('🔥 isPageNavigation flag:', dataTrackingRef.current.isPageNavigation);
		
		// Skip during page navigation to prevent chain reactions
		if (dataTrackingRef.current.isPageNavigation) {
			console.log('🔥 BLOCKED invDetails update during page navigation');
			return;
		}
		
		console.log('🔥 Setting fromInvDetData to invDetails');
		function fetchData() {
			setFromInvDetData(invDetails);
		}
		fetchData();
	}, [invDetails]);

	// set state for drData( from DR Table - DB )
	useEffect(() => {
		function fetchData() {
			console.log('🚚 DR DATA DEBUG - SAVED INVOICE:');
			console.log('🚚 drData type:', typeof drData);
			console.log('🚚 drData length:', drData ? drData.length : 'NULL/UNDEFINED');
			console.log('🚚 drData content:', drData);
			console.log('🚚 drData array check:', Array.isArray(drData));
			
			// Check for unexpected array indices
			if (Array.isArray(drData)) {
				console.log('🚚 drData keys:', Object.keys(drData));
				console.log('🚚 drData with indices:', drData.map((item, idx) => ({ index: idx, item })));
			}
			
			setFromDrData(drData);
			setMsgList(messagesList); // message list used for messages popup

			getLOVList();
		}
		fetchData();
	}, [drData, messagesList]);

	// set state for table data to handle data from dr list, add button, and from invoice details
	useEffect(() => {
		console.log('🔥 isPageNavigation flag:', dataTrackingRef.current.isPageNavigation);
		console.log('🔥 Current data lengths:', {
			fromInvDetData: fromInvDetData.length,
			fromDrData: fromDrData.length,
			fromAddData: fromAddData.length
		});
		
		// CRITICAL: Skip processing during page navigation to prevent duplicates
		if (dataTrackingRef.current.isPageNavigation) {
			console.log('🔥 BLOCKED - Page navigation in progress, skipping merge');
			return;
		}

		console.log('🔥 PROCESSING - Data merge allowed, proceeding...');
		
		let combineData = [];
		combineData.push(...fromInvDetData, ...fromDrData, ...fromAddData);
		
		console.log('🔥 combineData total length:', combineData.length);
		console.log('📊 Data sources:', {
			fromInvDetData: fromInvDetData.length,
			fromDrData: fromDrData.length, 
			fromAddData: fromAddData.length
		});
		console.log('📋 combineData items:', combineData.map((item, idx) => ({
			index: idx,
			desc: item.line_description,
			unit: item.unit_name,
			price: item.unit_price,
			qty: item.quantity,
			source: idx < fromInvDetData.length ? 'InvDet' : 
					idx < fromInvDetData.length + fromDrData.length ? 'Dr' : 'Add'
		})));

		// <-- start comment 20230202 merging of table lines with the same line description --------------

		// const arr = combineData;
		// const resultTblData = [...arr.reduce((r, o) => {
		// 	const key = o.line_description + '-' + o.unit_name; // multiple columns
		// 	// const key = o.line_description; // single column
			
		// 	const item = r.get(key) || Object.assign({}, o, {
		// 		quantity: 0,
		// 		line_amount: 0
		// 	});

		// 	item.quantity += parseFloat(o.quantity.toString().replace(/,/g, ''));
		// 	item.line_amount += parseFloat(o.line_amount.toString().replace(/,/g, ''));

		// 	return r.set(key, item);
		// }, new Map()).values()];

		// // test format --
		// const formatResultTblData = [...resultTblData.reduce((r, o) => {
		// 	const key = o.line_description + '-' + o.unit_name; // multiple columns
		// 	// const key = o.line_description; // single column
			
		// 	const item = r.get(key) || Object.assign({}, o, {
		// 		quantity: 0,
		// 		unit_price: 0,
		// 		line_amount: 0
		// 	});

		// 	item.quantity = formatValueOnChange(o.quantity.toString(), 'numeric');
		// 	item.unit_price = numberFormat(parseFloat(o.unit_price.toString().replace(/,/g, '')), 8);
		// 	item.line_amount = numberFormat(parseFloat(o.line_amount.toString().replace(/,/g, '')), 2);

		// 	return r.set(key, item);
		// }, new Map()).values()];
		// -- test format end

		// setTableData(formatResultTblData); // set table data with the merged table lines
		// handleTableData(formatResultTblData); // set the merged data to be returned to the parent component

		// -- 20230202 merging end --------------------------------------------------------------->
		
		// <-- start 20230202 - retrieve data without merging--------------------------------------
		const noMerge = combineData;
		console.log('🔄 Starting merge process...');
		const mergedTblData = [...combineData.reduce((r, o) => {
			// Normalize values for consistent merging
			const normalizeDesc = (desc) => desc ? desc.toString().trim().toUpperCase() : '';
			const normalizeUnit = (unit) => unit ? unit.toString().trim().toUpperCase() : '';
			
			// Merge key should ONLY use description + unit, NOT price
			// This allows editing amount/price without creating duplicate entries
			const key = `${normalizeDesc(o.line_description)}-${normalizeUnit(o.unit_name)}`;
			console.log(`🔑 Processing item: "${o.line_description}" -> key: "${key}"`);
		
			const existingItem = r.get(key);
			const item = existingItem || Object.assign({}, o, {
				quantity: 0,
				line_amount: 0,
			});
			
			if (existingItem) {
				console.log(`📝 Merging with existing item for key: "${key}"`);
			} else {
				console.log(`✨ Creating new item for key: "${key}"`);
			}
		
			item.quantity += parseFloat(o.quantity.toString().replace(/,/g, '') || 0);
			item.line_amount += parseFloat(o.line_amount.toString().replace(/,/g, '') || 0);
		
			return r.set(key, item);
		}, new Map()).values()];
		console.log('✅ Merge complete. Final merged data length:', mergedTblData.length);
		
		const formattedTblData = mergedTblData.map(o => ({
			...o,
			quantity: formatValueOnChange(o.quantity.toString(), 'numeric'),
			unit_price: numberFormat(parseFloat(o.unit_price.toString().replace(/,/g, '')), 7),
			line_amount: numberFormat(parseFloat(o.line_amount.toString().replace(/,/g, '')), 2),
		}));

		setTableData(formattedTblData); // set table data with the merged table lines
		handleTableData(formattedTblData); // set the merged data to be returned to the parent component
		// 20230202 no merge end ---------------------------------------------------------------->


		if(disabled){
			setEditableTableVal(false);
		}

		if(updateInvoiceRight === 'FALSE'){
			setEditableTableVal(false);
		}

		if(editButtonClicked){
			setEditableTableVal(true);
		}
	}, [fromAddData, fromDrData, fromInvDetData]);

	useEffect(()=>{
		if(editButtonClicked){
			setEditableTableVal(true);
		}
	}, [editButtonClicked]);


	//handle invoice total amount
	const selectInvoiceAmt = tableData.map(amt => 
		parseFloat(amt.line_amount.toString().replace(/,/g, '')) ? parseFloat(amt.line_amount.toString().replace(/,/g, '')) : 0.00
	);
	const totInvoiceAmt = selectInvoiceAmt.reduce((result, amt) => result + amt, 0.00);
	handleTotVal(totInvoiceAmt);

	// add invoice line - add button functionality
	const handleAdd = () => {
		const newAddData = {
			key: count,
			line_description: '',
			quantity: '0',
			unit_name: unitName,
			unit_price: '0.00000000',
			rebate: '0',
			line_amount: '0.00',
		};

		const addDataRet = fromAddData.filter((items) => items.line_description === ''); // control add button clicks
		// @ts-ignore
		if(addDataRet < 2){
			setFromAddData([...fromAddData, newAddData]);
			setCount(count + 1);
			
			// Navigate to last page to show the new record
			const newTotalRecords = tableData.length + 1;
			const lastPage = Math.max(0, Math.ceil(newTotalRecords / rowsPerPage) - 1);
			setPage(lastPage);
		}
	};

	//handle dr details
	async function handleDrOnChange(value) {
        // setTblLoading(true);
		handleDrList(value);
        let drList = value;

        if(isEditting) {
            // setTblLoading(false);
            const propsDrVal = invDetProps.dr_val === null ? [] : invDetProps.dr_val.split(',').map( n => parseInt(n, 10));
            drList = drList.filter(x => !propsDrVal.includes(x));
        }

        //filter data based on dr list
        if(drList.length > 0){
            const drValue = drList.reduce((result, item) => result ? `${result} ,${item}` : `${item}` , '');
            const drResult = await fetchDrDetailsAPI(drValue);

            if(drResult){
                // Truncate line_description at pipe character if present
                const truncatedDrResult = drResult.map(item => {
                    if (item.line_description) {
                        const pipeIndex = item.line_description.indexOf('|');
                        if (pipeIndex !== -1) {
                            item.line_description = item.line_description.substring(0, pipeIndex);
                        }
                    }
                    return item;
                });
                return setDrData(truncatedDrResult);
            };

            return setDrData(drResult);
        }else{
            // setTblLoading(false);
        }
        return setDrData([]);
    }

	function handleDelInvDet(record){
		const newRecord = tableData.filter(item => item.key !== record.key);// data invDetails
		setTableData(newRecord);
	
		const newAddData = fromAddData.filter(item => item.key !== record.key);// data from add button
		const newDrData = fromDrData.filter(item => item.key !== record.key);// data from dr list
		const newInvData = fromInvDetData.filter(item => item.key !== record.key);// data invDetails

		setFromAddData(newAddData);
		setFromDrData(newDrData);
		setFromInvDetData(newInvData);

		// Adjust page if current page becomes empty after deletion
		const newTotalRecords = newRecord.length;
		const maxPage = Math.max(0, Math.ceil(newTotalRecords / rowsPerPage) - 1);
		if (page > maxPage) {
			setPage(maxPage);
		}

		if(record.invoice_line_id !== undefined){
			handleDeleteList(record);
		};
	};

	// validate duplicate line records
	const validateDuplicateRecord = (currentRow) => {
		// Skip validation for empty line descriptions
		if (!currentRow.line_description || currentRow.line_description.trim() === '') {
			return true;
		}

		const currentLineDesc = currentRow.line_description.trim().toUpperCase();
		const currentUnitName = currentRow.unit_name && currentRow.unit_name.trim() ? currentRow.unit_name.trim().toUpperCase() : '';

		// Check ONLY against tableData (the final merged display data) to avoid false positives
		// when editing merged rows from the invoice details
		const duplicateRecord = tableData.find(item => 
			item.key !== currentRow.key &&
			item.line_description && 
			item.line_description.trim().toUpperCase() === currentLineDesc &&
			(item.unit_name && item.unit_name.trim() ? item.unit_name.trim().toUpperCase() : '') === currentUnitName
		);
		
		if (duplicateRecord) {
			Message.error({ message: "You are not allowed to input same line record" });
			return false;
		}
		return true;
	};

	// handle the save function from editable Cell
	const handleSave = (row, val) => {
		// Validate for duplicate records before saving
		if (!validateDuplicateRecord(row)) {
			return;
		}
		// <-- start 20230202 comment merging of details removed -----------------------------------
		// if data comes from invoice details list ----------------------------------------
		const checkInvDetData = [...fromInvDetData];
		const invDetIndex = checkInvDetData.findIndex(item => row.key === item.key);

		if(invDetIndex >= 0){
			const invDetItem = checkInvDetData[invDetIndex];
			// set table column amount value
			if(
				row.quantity.toString() !== invDetItem.quantity.toString()
				|| row.unit_price.toString() !== invDetItem.unit_price.toString()
			){
				const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
								*parseFloat(row.unit_price.toString().replace(/,/g, ''));

				row.line_amount = numberFormat(row_line_amt, 2);
			}
			// set data table row update
			checkInvDetData.splice(invDetIndex, 1, { ...invDetItem, ...row });
			setFromInvDetData(checkInvDetData);
		};
		
		// if data comes from dr list ----------------------------------------
		const checkDrData = [...fromDrData];
		const drIndex = checkDrData.findIndex(item => row.key === item.key);

		if(drIndex >= 0){
			const drItem = checkDrData[drIndex];
			// set table column amount value
			if(
				row.quantity.toString() !== drItem.quantity.toString()
				|| row.unit_price.toString() !== drItem.unit_price.toString()
			){
				const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
								*parseFloat(row.unit_price.toString().replace(/,/g, ''));

				row.line_amount = numberFormat(row_line_amt, 2);
			}
			// set data table row update
			checkDrData.splice(drIndex, 1, { ...drItem, ...row });
			setFromDrData(checkDrData);
		};

		// if data comes from add button ----------------------------------------
		const checkAddData = [...fromAddData]
		const addDataIndex = checkAddData.findIndex(item => row.key === item.key);
		
		if(addDataIndex >= 0){
			const addDataItem = checkAddData[addDataIndex];
			// set table column amount value
			if(
				row.quantity.toString() !== addDataItem.quantity.toString()
				|| row.unit_price.toString() !== addDataItem.unit_price.toString() 
			){
				const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
								*parseFloat(row.unit_price.toString().replace(/,/g, ''));

				row.line_amount = numberFormat(row_line_amt, 2);
			}
			// set data table row update
			checkAddData.splice(addDataIndex, 1, { ...addDataItem, ...row });
			setFromAddData(checkAddData);
		};
		// no merging end ----------------------------------------------->

		// <-- start 20230202 commented to remove merging of details ---------------------------------
		// const m0020 = msgList.filter((items) => items.message_code === 'M0020');

		// check existing lines with the same line description of the current row
		// const handleTblData = [...tableData];
		// const tblDataRet = handleTblData.filter((items) => 
		// 	items.line_description === (val.line_description === undefined ? '' : val.line_description)
		// );

		// if(tblDataRet.length < 1 && val.line_description !== ''){
		// 	// table data list ----------------------------------------
		// 	const checkTblData = [...tableData];
		// 	const tblIndex = checkTblData.findIndex(item => row.key === item.key);

		// 	if(tblIndex >= 0){
		// 		// clear data from set state start --
		// 		const newAddData = fromAddData.filter(item => item.line_description !== row.line_description);// data from add button
		// 		const newDrData = fromDrData.filter(item => item.line_description !== row.line_description);// data from dr list

		// 		setFromAddData(newAddData);
		// 		setFromDrData(newDrData);
		// 		// -- clear data end

		// 		const tblItem = checkTblData[tblIndex];
		// 		// set table column amount value
		// 		if(
		// 			row.quantity.toString() !== tblItem.quantity.toString()
		// 			|| row.unit_price.toString() !== tblItem.unit_price.toString()
		// 		){
		// 			const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
		// 							*parseFloat(row.unit_price.toString().replace(/,/g, ''));

		// 			row.line_amount = numberFormat(row_line_amt, 2);
		// 		}
		// 		// set data table row update
		// 		checkTblData.splice(tblIndex, 1, { ...tblItem, ...row });
		// 		setTableData(checkTblData);
		// 	};

		// 	// if data comes from invoice details list ----------------------------------------
		// 	const checkInvDetData = [...fromInvDetData];
		// 	const invDetIndex = checkInvDetData.findIndex(item => row.key === item.key);

		// 	if(invDetIndex >= 0){
		// 		const invDetItem = checkInvDetData[invDetIndex];
		// 		// set table column amount value
		// 		if(
		// 			row.quantity.toString() !== invDetItem.quantity.toString()
		// 			|| row.unit_price.toString() !== invDetItem.unit_price.toString()
		// 		){
		// 			const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
		// 							*parseFloat(row.unit_price.toString().replace(/,/g, ''));

		// 			row.line_amount = numberFormat(row_line_amt, 2);
		// 		}
		// 		// set data table row update
		// 		checkInvDetData.splice(invDetIndex, 1, { ...invDetItem, ...row });
		// 		setFromInvDetData(checkInvDetData);
		// 	};
			
		// 	// if data comes from dr list ----------------------------------------
		// 	const checkDrData = [...fromDrData];
		// 	const drIndex = checkDrData.findIndex(item => row.key === item.key);

		// 	if(drIndex >= 0){
		// 		const drItem = checkDrData[drIndex];
		// 		// set table column amount value
		// 		if(
		// 			row.quantity.toString() !== drItem.quantity.toString()
		// 			|| row.unit_price.toString() !== drItem.unit_price.toString()
		// 		){
		// 			const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
		// 							*parseFloat(row.unit_price.toString().replace(/,/g, ''));

		// 			row.line_amount = numberFormat(row_line_amt, 2);
		// 		}
		// 		// set data table row update
		// 		checkDrData.splice(drIndex, 1, { ...drItem, ...row });
		// 		setFromDrData(checkDrData);
		// 	};

		// 	// if data comes from add button ----------------------------------------
		// 	const checkAddData = [...fromAddData]
		// 	const addDataIndex = checkAddData.findIndex(item => row.key === item.key);
			
		// 	if(addDataIndex >= 0){
		// 		const addDataItem = checkAddData[addDataIndex];
		// 		// set table column amount value
		// 		if(
		// 			row.quantity.toString() !== addDataItem.quantity.toString()
		// 			|| row.unit_price.toString() !== addDataItem.unit_price.toString() 
		// 		){
		// 			const row_line_amt = parseFloat(row.quantity.toString().replace(/,/g, ''))
		// 							*parseFloat(row.unit_price.toString().replace(/,/g, ''));

		// 			row.line_amount = numberFormat(row_line_amt, 2);
		// 		}
		// 		// set data table row update
		// 		checkAddData.splice(addDataIndex, 1, { ...addDataItem, ...row });
		// 		setFromAddData(checkAddData);
		// 	};
		// }else if(tblDataRet.length > 0 && val.line_description !== '-'){
		// 	const checkTblData = [...tableData];
		// 	const chIndex = checkTblData.findIndex(item => row.key === item.key);

		// 	if(chIndex >= 0){
		// 		const chItem = checkTblData[chIndex];
				
		// 		if(row.line_description !== chItem.line_description){
		// 			Message.error({ message: m0020[0].message_display });
		// 		}
		// 	};
		// }; // --tblDataRet
		// no merging end ------------------------------------------------------------------->
	};

	const defaultColumns = [
		{
			title: 'LINE DESCRIPTION',
			dataIndex: 'line_description',
			editable: editableTableVal,
			width: '35%',
			// render handled inline in MUI table
		},
		{
			title: 'QUANTITY',
			dataIndex: 'quantity',
			editable: editableTableVal,
			width: '15%',
			// render handled inline in MUI table
		},
		{
			title: 'UNIT',
			dataIndex: 'unit_name',
			editable: editableTableVal,
			width: '15%',
			// render handled inline in MUI table
		},
		{
			title: 'UNIT PRICE',
			dataIndex: 'unit_price',
			editable: editableTableVal,
			width: '15%',
			// render handled inline in MUI table
		},
		{
			title: 'AMOUNT',
			dataIndex: 'line_amount',
			editable: editableTableVal,
			width: '15%',
			// render handled inline in MUI table
		},
		{
			title: 'OPERATION',
			dataIndex: 'operation',
			width: '5%',
			// render handled inline in MUI table
		},
	];

	const isCellDisabled = () => (editButtonClicked ? false : updateInvoiceRight === 'TRUE' ? disabled : true);

	const pagedRows = tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
	
	// Debug: Log tableData whenever it changes  
	console.log('📋 PAGINATION DEBUG:', {
		'Total tableData length': tableData.length,
		'Current page': page,
		'Rows per page': rowsPerPage, 
		'pagedRows length': pagedRows.length,
		'fromInvDetData length': fromInvDetData.length,
		'fromDrData length': fromDrData.length,
		'fromAddData length': fromAddData.length
	});
	
	// Debug: Log actual tableData content to check for duplicates
	console.log('📋 ACTUAL TABLEDATA:', tableData.map((item, idx) => ({
		index: idx,
		key: item.key,
		description: item.line_description,
		quantity: item.quantity,
		price: item.unit_price
	})));

	const handleChangePage = (_event, newPage) => {
		console.log('🔥 PAGE NAVIGATION START: from', page, 'to', newPage);
		console.log('🔥 Setting isPageNavigation = true');
		
		// Block merging during page navigation
		dataTrackingRef.current.isPageNavigation = true;
		setPage(newPage);
		
		// Reset flag after sufficient delay to prevent any merge processing
		setTimeout(() => {
			dataTrackingRef.current.isPageNavigation = false;
			console.log('🔥 PAGE NAVIGATION END: flag cleared, merge now allowed');
		}, 500); // Increased to 500ms for safety
	};
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<div>
			<Form>
				<Row gutter={[8,1]} align="bottom">
					<Col span={6}>
						<Form.Item label="SELECT DR NO">
						<Select placeholder="Select DR NO."
								// style={{ width: '100%', marginTop: 5 }}
								mode='multiple'
								allowClear
								onChange={handleDrOnChange}
								disabled={editButtonClicked === true ? false : soldToDisabled}
								value={selectedDrIdList}
								optionFilterProp="label"
								showSearch
								filterOption={(input, option) => {
									const label = option && option.label ? String(option.label) : '';
									return label.toLowerCase().includes(input.toLowerCase());
								}}
								notFoundContent="No DR numbers found"
							>
								{drNoOptions}
							</Select>
						</Form.Item>
					</Col>
					<Col span={9}>
						<Button
							onClick={handleAdd}
							type="primary"
							style={{ marginBottom: 3 }}
							icon={<PlusCircleOutlined />}
							disabled={editButtonClicked === true ? false : disabled}
						>
							ADD BLANK INVOICE LINE
						</Button>
					</Col>
					<Col span={9}>
						<SearchPagerRight pageTotal={tableData.length} pageSize={pageSize} />
					</Col>
				</Row>
			</Form>

			{/* Material-UI Table (primary) */}
			<TableContainer component={Paper} style={{ marginTop: 16 }}>
			  <MuiTable>
			    <TableHead>
			      <TableRow>
			        {defaultColumns.map(col => (
			          <TableCell 
			            key={col.dataIndex || col.title}
			            style={TABLE_HEADER_STYLE}
			          >
			            {col.title}
			          </TableCell>
			        ))}
			      </TableRow>
			    </TableHead>
			    <TableBody>
			      {pagedRows.map((row, idx) => {
			        // Create truly unique key to prevent React rendering conflicts
			        const uniqueKey = row.key ? `row_${row.key}` : `add_${row.line_description}_${idx}`;
			        return (
			        <TableRow key={uniqueKey} className={'editable-row'}>
			          {defaultColumns.map(col => {
			            const key = col.dataIndex || col.title;
			            if (col.dataIndex === 'operation') {
			              return (
			                <TableCell 
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  {tableData.length >= 1 ? (
			                    <Typography.Link 
			                      title="Sure to delete?" 
			                      onClick={() => handleDelInvDet(row)} 
			                      disabled={editButtonClicked === true ? false : disabled}
			                      style={{ 
			                        fontSize: '14px',
			                        fontFamily: 'Karla, sans-serif'
			                      }}
			                    >
			                      Delete
			                    </Typography.Link>
			                  ) : null}
			                </TableCell>
			              );
			            }

			            const disabledCell = isCellDisabled();
			            if (col.dataIndex === 'line_description') {
			              const editingKey = `${row.key}_line_description`;
			              const displayValue = editingValues[editingKey] !== undefined ? editingValues[editingKey] : (row.line_description || '');

			              return (
			                <TableCell
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  <TextArea
			                    className='editableCellInput'
			                    value={displayValue}
			                    disabled={disabledCell}
			                    maxLength={750}
			                    onChange={e => setEditingValues(prev => ({ ...prev, [editingKey]: e.target.value.toUpperCase() }))}
			                    onBlur={e => {
			                      handleSave({ ...row, line_description: e.target.value.toUpperCase() }, {});
			                      setEditingValues(prev => ({ ...prev, [editingKey]: undefined }));
			                    }}
			                    placeholder="Enter line description"
			                    rows={2}
			                    style={{
			                      width: '100%',
			                      ...TABLE_INPUT_STYLE
			                    }}
			                  />
			                </TableCell>
			              );
			            }

			            if (col.dataIndex === 'quantity') {
			              return (
			                <TableCell 
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  <Input
			                    className='editableCellInput'
			                    value={row.quantity}
			                    disabled={disabledCell}
			                    onChange={e => handleSave({ ...row, quantity: e.target.value }, {})}
			                    style={TABLE_INPUT_STYLE}
			                  />
			                </TableCell>
			              );
			            }

			            if (col.dataIndex === 'unit_name') {
			              return (
			                <TableCell 
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  <Select
			                    className='editableCellInput'
			                    value={row.unit_name}
			                    disabled={disabledCell}
			                    loading={unitsLoading}
			                    onChange={value => handleSave({ ...row, unit_name: value }, {})}
			                    placeholder="Select Unit"
			                    style={{ 
			                      width: '100%',
			                      ...TABLE_INPUT_STYLE
			                    }}
			                  >
			                    {unitsOptions}
			                  </Select>
			                </TableCell>
			              );
			            }

			            if (col.dataIndex === 'unit_price') {
			              const editingKey = `${row.key}_unit_price`;
			              const displayValue = editingValues[editingKey] !== undefined ? editingValues[editingKey] : row.unit_price;
			              
			              return (
			                <TableCell 
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  <Input
			                    className='editableCellInput'
			                    value={displayValue}
			                    disabled={disabledCell}
			                    onFocus={e => {
			                      // Select all text on focus for easy editing
			                      e.target.select();
			                      // Clear default value on focus if it's the default "0.00000000"
			                      if (displayValue === "0.00000000") {
			                        setEditingValues(prev => ({ ...prev, [editingKey]: '' }));
			                      }
			                    }}
			                    onChange={e => {
			                      // Allow only numbers and decimal point
			                      const value = e.target.value.replace(/[^0-9.]/g, '');
			                      setEditingValues(prev => ({ ...prev, [editingKey]: value }));
			                    }}
			                    onBlur={e => {
			                      handleSave({ ...row, unit_price: e.target.value }, {});
			                      setEditingValues(prev => ({ ...prev, [editingKey]: undefined }));
			                    }}
			                    style={TABLE_INPUT_STYLE}
			                  />
			                </TableCell>
			              );
			            }

			            if (col.dataIndex === 'line_amount') {
			              return (
			                <TableCell 
			                  key={key}
			                  style={TABLE_CELL_STYLE}
			                >
			                  <Input
			                    className='editableCellInput'
			                    value={row.line_amount}
			                    disabled={disabledCell}
			                    onChange={e => handleSave({ ...row, line_amount: e.target.value }, {})}
			                    style={TABLE_INPUT_STYLE}
			                  />
			                </TableCell>
			              );
			            }

			            // Fallback raw value
			            return (
			              <TableCell 
			                key={key}
			                style={TABLE_CELL_STYLE}
			              >
			                {row[col.dataIndex]}
			              </TableCell>
			            );
			          })}
			        </TableRow>
			        );
			      })}
			    </TableBody>
			  </MuiTable>
			</TableContainer>

			<TablePagination
				component="div"
				count={tableData.length}
				page={page}
				onPageChange={handleChangePage}
				rowsPerPage={rowsPerPage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				rowsPerPageOptions={[]}
				style={TABLE_PAGINATION_STYLE}
			/>
		</div>
	);
}

export default InvoiceTable;
